export const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#0f0817',
    color: '#ffffff',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  },
  header: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    background: 'rgba(15, 8, 23, 0.95)',
    backdropFilter: 'blur(10px)',
    borderBottom: '1px solid rgba(124, 58, 237, 0.2)'
  },
  headerContent: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '18px',
    fontWeight: '600',
    color: '#ffffff'
  },
  logoIcon: {
    width: '28px',
    height: '28px',
    background: 'linear-gradient(135deg, #7c3aed, #8b5cf6)',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  nav: {
    display: 'flex',
    alignItems: 'center',
    gap: '32px'
  },
  navLink: {
    color: '#cccccc',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'color 0.3s',
    cursor: 'pointer'
  },
  navButton: {
    background: 'transparent',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    color: '#ffffff',
    padding: '8px 16px',
    borderRadius: '6px',
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'all 0.3s'
  },
  hero: {
    marginTop: '80px',
    padding: '60px 24px 80px',
    textAlign: 'center',
    background: 'linear-gradient(180deg, rgba(124, 58, 237, 0.1) 0%, rgba(15, 8, 23, 0) 100%)'
  },
  heroContent: {
    maxWidth: '800px',
    margin: '0 auto'
  },
  heroTitle: {
    fontSize: 'clamp(32px, 6vw, 56px)',
    fontWeight: '600',
    lineHeight: 1.1,
    marginBottom: '24px',
    color: '#ffffff'
  },
  heroSubtitle: {
    fontSize: '20px',
    color: '#cccccc',
    lineHeight: 1.5,
    marginBottom: '40px',
    fontWeight: '400'
  },
  ctaButton: {
    background: 'linear-gradient(135deg, #7c3aed, #8b5cf6)',
    border: 'none',
    color: '#ffffff',
    padding: '16px 32px',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'all 0.3s',
    marginBottom: '60px'
  },
  section: {
    padding: '80px 24px'
  },
  sectionContent: {
    maxWidth: '1200px',
    margin: '0 auto'
  },
  sectionTitle: {
    fontSize: 'clamp(28px, 5vw, 40px)',
    fontWeight: '600',
    marginBottom: '16px',
    textAlign: 'center'
  },
  sectionSubtitle: {
    fontSize: '18px',
    color: '#cccccc',
    textAlign: 'center',
    marginBottom: '60px',
    lineHeight: 1.6,
    maxWidth: '600px',
    margin: '0 auto 60px'
  },
  pillarsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '32px',
    marginBottom: '80px'
  },
  pillarCard: {
    background: 'rgba(124, 58, 237, 0.05)',
    border: '1px solid rgba(124, 58, 237, 0.2)',
    borderRadius: '12px',
    padding: '32px',
    textAlign: 'center',
    transition: 'all 0.3s',
    cursor: 'pointer'
  },
  pillarIcon: {
    width: '64px',
    height: '64px',
    margin: '0 auto 24px',
    borderRadius: '12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(124, 58, 237, 0.15)',
    color: '#8b5cf6'
  },
  pillarTitle: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '12px'
  },
  pillarDescription: {
    color: '#cccccc',
    lineHeight: 1.6,
    fontSize: '14px'
  },
  keyFeaturesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
    gap: '24px'
  },
  featureCard: {
    background: 'rgba(124, 58, 237, 0.05)',
    border: '1px solid rgba(124, 58, 237, 0.2)',
    borderRadius: '12px',
    padding: '24px'
  },
  featureTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  featureDescription: {
    color: '#cccccc',
    lineHeight: 1.6,
    fontSize: '14px'
  },
  useCasesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '24px'
  },
  useCaseCard: {
    background: 'rgba(124, 58, 237, 0.05)',
    border: '1px solid rgba(124, 58, 237, 0.2)',
    borderRadius: '12px',
    padding: '24px',
    borderLeft: '4px solid #7c3aed'
  },
  useCaseTitle: {
    fontSize: '16px',
    fontWeight: '600',
    marginBottom: '8px'
  },
  useCaseIndustry: {
    fontSize: '12px',
    color: '#8b5cf6',
    marginBottom: '12px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  useCaseDescription: {
    color: '#cccccc',
    fontSize: '14px',
    lineHeight: 1.5
  },
  finalCta: {
    background: 'linear-gradient(135deg, rgba(124, 58, 237, 0.1), rgba(139, 92, 246, 0.1))',
    borderRadius: '16px',
    padding: '60px 40px',
    textAlign: 'center'
  },
  finalCtaTitle: {
    fontSize: 'clamp(24px, 4vw, 36px)',
    fontWeight: '600',
    marginBottom: '16px'
  },
  finalCtaSubtitle: {
    fontSize: '18px',
    color: '#cccccc',
    marginBottom: '32px',
    lineHeight: 1.5
  },
  buttonGroup: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  secondaryButton: {
    background: 'transparent',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    color: '#ffffff',
    padding: '16px 32px',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    transition: 'all 0.3s'
  }
};